/**
 * Header co-branding compartilhado para todas as result pages e forms públicos.
 * Aceita 1..N parceiros com logos. Separador "&" entre eles.
 */
import { ReactNode } from 'react'

export type Partner = {
  src: string
  alt: string
  height?: number  // default 56
}

export interface AssessmentHeaderProps {
  partners: Partner[]
  slogan?: string
  tagline?: string  // ex: "Assessment Cibersegurança · ~20 min"
  sticky?: boolean
  className?: string
  children?: ReactNode
}

export default function AssessmentHeader({
  partners,
  slogan,
  tagline,
  sticky = true,
  className = '',
  children,
}: AssessmentHeaderProps) {
  return (
    <header className={`border-b border-slate-800 bg-slate-900/50 ${sticky ? 'sticky top-0 backdrop-blur z-10' : ''} ${className}`}>
      <div className="max-w-5xl mx-auto px-4 py-5">
        <div className="flex items-center justify-center gap-6 flex-wrap">
          {partners.map((p, idx) => (
            <div key={idx} className="flex items-center gap-6">
              {idx > 0 && <span className="text-3xl font-light text-slate-400 leading-none">&</span>}
              <img src={p.src} alt={p.alt}
                style={{ height: `${p.height ?? 56}px`, width: 'auto' }} />
            </div>
          ))}
        </div>
        {slogan && (
          <p className="text-center text-sm text-slate-300 mt-3 italic">{slogan}</p>
        )}
        {tagline && (
          <p className="text-center text-[10px] uppercase tracking-widest text-cyan-400/70 mt-2">{tagline}</p>
        )}
        {children}
      </div>
    </header>
  )
}
